module.exports = __webpack_public_path__ + "static/media/accessibilityNewKTM.1d983fae.svg";